import React from 'react'

import { ApiDocsSectionWrapper } from '@/components/common/api-docs-section-wrapper'
import { docsClipsLinksIndex } from '@/config/links'
import { DocsSection } from '@/components/common/docs-section'

import SearchEndpoint from './search-endpoint.mdx'
import TrendingEndpoint from './trending-endpoint.mdx'
import ContentByIdEndpoint from './content-by-id-endpoint.mdx'
import ContentByIdsEndpoint from './content-by-ids-endpoint.mdx'

export const Endpoints: React.FC = () => {
  return (
    <ApiDocsSectionWrapper>
      <DocsSection
        anchorId={docsClipsLinksIndex.searchEndpoint.hash}
        dividerLine={false}
        pathname={docsClipsLinksIndex.searchEndpoint.pathname}
      >
        <SearchEndpoint />
      </DocsSection>
      <DocsSection
        anchorId={docsClipsLinksIndex.trendingEndpoint.hash}
        pathname={docsClipsLinksIndex.trendingEndpoint.pathname}
      >
        <TrendingEndpoint />
      </DocsSection>
      <DocsSection
        anchorId={docsClipsLinksIndex.contentByIDEndpoint.hash}
        pathname={docsClipsLinksIndex.contentByIDEndpoint.pathname}
      >
        <ContentByIdEndpoint />
      </DocsSection>
      <DocsSection
        anchorId={docsClipsLinksIndex.contentByMultipleIDsEndpoint.hash}
        pathname={docsClipsLinksIndex.contentByMultipleIDsEndpoint.pathname}
      >
        <ContentByIdsEndpoint />
      </DocsSection>
    </ApiDocsSectionWrapper>
  )
}
